import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as serviceActions from "../../actions/serviceActions";

const ServiceSelect = ({
  value,
  isMulti = false,
  onChange,
  services = [],
  actions,
  placeholder,
  label
}) => {
  if (!services.length) {
    actions.loadServices();
  }

  const options = services
    .map((d) => ({
      label: d.description,
      value: d._id
    }))
    .sort((a, b) => {
      if (a.label > b.label) return 1;
      if (b.label > a.label) return -1;
      return 0;
    });
  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="service-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        id="service-select"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable
        onChange={onChange}
        isMulti={isMulti}
      />
    </React.Fragment>
  );
};

ServiceSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  services: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string
};

ServiceSelect.defaultProps = {
  placeholder: "Service"
};

function mapStatesToProps(state) {
  return {
    services: state.reducers.services
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...serviceActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ServiceSelect);
